export enum InboxesRoutes {
  root = 'inboxes',
  new = 'new',
  members = 'members',
  teams = 'teams',
  numbers = 'numbers',
  settings = 'settings',
  messaging = 'messaging',
  calling = 'calling',
  general = 'general',
  smartInbox = 'smart-inbox',
  conversationAssignment = 'conversation-assignment',
  businessHours = 'business-hours',
  aiAutomation = 'ai-automation',
  smartCallFlow = 'smart-call-flow',
  addNumber = 'add-number',
  assignNumber = 'assign-number',
  buyNumber = 'buy-number',
  addNumberFromApp = 'add-number-from-app',
  textEnableLandline = 'text-enable-landline',
}

export enum NewInboxRoutes {
  steps = 'steps',
  newInbox = 'new-inbox',
  howAddNumber = 'how-add-number',
  addSalesmsgNumbers = 'add-salesmsg-numbers',
  payment = 'payment',
  chooseNumber = 'choose-number',
  selectAppAndNumbers = 'select-app-and-numbers',
  enterNumber = 'enter-number',
  enterAddress = 'enter-address',
  verifyNumber = 'verify-number',
  authorizationDocument = 'authorization-document',
}
